export default "/_next/static/chunks/fonts/MaterialCommunityIcons-5d42b4e60858731e7b6504400f7e3d8e.ttf";